import { get, getDatabase, ref } from 'firebase/database';

// Building group tags are owned by buildingTagsApi; re-exported here for existing callers.
export { getBuildingTags } from './buildingTagsApi';

export interface LocationCategoryConfig {
    [key: string]: { name: string; parent?: string };
}

export interface LocationCategoriesConfig {
    category1?: LocationCategoryConfig;
    category2?: LocationCategoryConfig;
    category3?: LocationCategoryConfig;
    category4?: LocationCategoryConfig;
    category5?: LocationCategoryConfig;
    labels: {
        category1: string;
        category2: string;
        category3: string;
        category4: string;
        category5: string;
    };
}

export async function getLocationCategories(): Promise<LocationCategoriesConfig | null> {
    try {
        const db = getDatabase();
        const snapshot = await get(ref(db, 'locationCategories'));
        return snapshot.exists() ? (snapshot.val() as LocationCategoriesConfig) : null;
    } catch (err) {
        console.error('Failed to load categories data', err);
        return null;
    }
}
